/**
 * Shared boost analytics event names. Emission stays on
 * `useAnalytics().track(BoostEvents.X, payload)` at the call site;
 * this file is constants-only.
 *
 * Naming: PascalCase, no spaces, matches the existing convention in
 * `analytics-context.tsx` ("PageView") and the original three boost events
 * inlined in `boost-confirm-modal.tsx` ("BoostConfirmClicked",
 * "BoostSucceeded", "BoostFailed"). See review 010 — telemetry was
 * previously snake_case here and PascalCase at the modal call sites.
 */
const BoostEvents = {
  BoostConfirmClicked: "BoostConfirmClicked",
  BoostSucceeded: "BoostSucceeded",
  BoostFailed: "BoostFailed",
  BoostCanceled: "BoostCanceled",
  BoostButtonClicked: "BoostButtonClicked",
} as const;

type BoostEventName = (typeof BoostEvents)[keyof typeof BoostEvents];

export { BoostEvents, type BoostEventName };
